import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const IssueModal = ({ isOpen, setIsOpen, editData, fetchPlans }) => {
    const [data, setData] = useState({
        issue: ""
    });

    useEffect(() => {
        if (editData) {
            setData({ issue: editData.issue });
        } else {
            setData({ issue: "" });
        }
    }, [editData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editData ? "PUT" : "POST";
        const url = editData
            ? `https://backend.impactjournal.co.in/issue/${editData.id}`
            : "https://backend.impactjournal.co.in/issue";

        try {
            const response = await fetch(url, {
                method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data)
            });
            if (response.ok) {
                toast.success(editData ? "Volume Updated" : "Volume Added");
                fetchPlans();
                setData({ issue: "" });
                setIsOpen(false);
            } else {
                const error = await response.json();
                toast.error(error.message);
                console.error("Server Error:", error.message);
            }
        } catch (error) {
            toast.error("Request failed");
            console.error("Request Error:", error);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="oms-modal-title">{editData ? "Edit Issue" : "Add Issue"}</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Issue Name</label>
                        <input
                            type="text"
                            name="issue"
                            value={data.issue}
                            onChange={handleChange}
                            placeholder="Enter Issue name"
                            required
                        />
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">
                            {editData ? "Update" : "Submit"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default IssueModal;
